import { render, staticRenderFns } from "./award-money-modal.vue?vue&type=template&id=608c315d&scoped=true&lang=pug&"
import script from "./award-money-modal.vue?vue&type=script&lang=js&"
export * from "./award-money-modal.vue?vue&type=script&lang=js&"
import style0 from "./award-money-modal.vue?vue&type=style&index=0&id=608c315d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608c315d",
  null
  
)

export default component.exports